import React from 'react'
import { useNavigate } from 'react-router-dom'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import illustration from '../../../../shared/assets/no-active-trademarks-stub-illustration.svg'
import { StubContactLinks } from '../../../../lib/widgets/stubs/StubContactLinks'

interface NoActiveTrademarksStubProps {
  project: string
}

export const NoActiveTrademarksStub = ({ project }: NoActiveTrademarksStubProps) => {
  const navigate = useNavigate()

  return (
    <div className={'flex justify-center'}>
      <div className={'flex w-full max-w-[320px] flex-col items-center gap-[24px]'}>
        <div className={'w-full'}>
          <img alt={'Illustration'} className={'mx-auto max-w-full'} src={illustration} />
        </div>
        <div className={'flex w-full flex-col gap-[16px]'}>
          <div className={'flex flex-col items-center'}>
            <h2 className={'text-center text-[24px]'}>No active trademarks</h2>
          </div>
          <div
            className={'flex w-full flex-col gap-[16px] rounded-[16px] bg-focus/[0.06] p-[16px]'}
          >
            <p className={'text-center text-focus-500'}>
              Go to Settings and activate your current trademark or create a new one
            </p>
          </div>
          <div className={'flex justify-center'}>
            <BpButton
              className={'uppercase'}
              size={'md'}
              onClick={() => {
                navigate(`/projects/${project}/trademarks`)
              }}
            >
              GO TO TRADEMARKS
            </BpButton>
          </div>
        </div>
        <div className={'flex flex-col gap-[8px]'}>
          <p className={'text-center text-[15px] text-[#8E7CA7]'}>Contact us for help</p>
          <StubContactLinks />
        </div>
      </div>
    </div>
  )
}
